import React from 'react';
import MediaQuery from 'react-responsive';
import {Shop} from 'interfaces';
import {Grid} from 'components/MarketingAssets';
import {withI18n, WithI18nProps} from 'packages/@shopify/react-i18n';
import * as locales from './locales';
import ShopGrid from './components/ShopGrid';
import ShopTable from './components/ShopTable';
import {ShopsEmpty} from './components/ShopsEmpty';

export interface ShopDisplayProps {
  shops: Shop[];
  tile: boolean;
  countString: string;
}

const style = {
  count: 'grid__item gutter-bottom--reset shop-filters__header__label',
  countWrap: 'shop-filters gutter-bottom--half grid',
};

const MIN_TABLE_WIDTH = 750;

function ShopDisplayComponent({
  shops,
  tile = false,
  countString,
  i18n,
}: ShopDisplayProps & WithI18nProps) {

  if (!shops.length) {
    return (
      <ShopsEmpty heading={i18n.translate('heading')}>
        {i18n.translate('content', {replacements: {
          link: (
            <a href={i18n.translate('url')}>
              {i18n.translate('link')}
            </a>
          ),
        }})}
      </ShopsEmpty>
    );
  }
  return (
    <React.Fragment>
      <div className={style.countWrap}>
        <p className={style.count}>{countString}</p>
      </div>
      <MediaQuery query={`(max-width: ${MIN_TABLE_WIDTH}px)`}>
        {(matches) => {
          const displayAsTile = tile || matches;
          return (
            <Grid equalHeight>
              {displayAsTile
                ? <ShopGrid shops={shops} />
                : <ShopTable shops={shops} />
              }
            </Grid>
          );
        }}
      </MediaQuery>
    </React.Fragment>
  );
}

export const ShopDisplay = withI18n({
  id: 'ShopDisplay',
  fallback: locales.en,
})(ShopDisplayComponent);

export default ShopDisplay;
